<template>
<div class="vRow" style="padding:0 0 0 0;" v-if="ready">
<div class="row" >

   <div class="col s4" style="border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      <div class="row pad-in" v-if="v.analisilabel.length>38">
         <el-tooltip :open-delay="800" :content="dLabel" placement="bottom" effect="dark"><div class="col s12 yo-text-bold yo-valign-text-center" style="height:32px;" :class="(v.gruppo==1) ? 'yo-color-primary' : 'grey'" >{{v.analisilabel | maxlenght(40)}}</div></el-tooltip>
      </div>
      <div class="row pad-in" v-else>
         <div class="col s12 yo-text-bold yo-valign-text-center" style="height:32px;" :class="(v.gruppo==1) ? 'yo-color-primary' : 'grey'" >{{v.analisilabel | maxlenght(40)}}</div>
      </div>

      <div class="row pad-in" :class="variabile+'-'+vitem.id" v-if="v.tipoanalisi==1" v-for="vitem in vData[0]" :key="vitem.id">
          <div class="col s12 yo-align-right yo-text-s yo-valign-text-center" style="height:24px;">{{vitem.label | maxlenght(56)}}</div>
      </div>

      <div class="row pad-in"  v-if="v.tipoanalisi==2">
         <div class="col s12 yo-valign-text-center" style="height:24px;"></div>
      </div>

      <div class="row pad-in"  v-if="v.tipoanalisi==2">
         <div class="col s12 yo-valign-text-center" style="height:24px;"></div>
      </div>

      <div class="row pad-in" >
          <div class="col s12 yo-align-right yo-text-s yo-valign-text-center" style="height:24px;">Dati mancanti</div>
      </div>

   </div>

   <div class="col s4" style="border-left:2px solid white;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      <div class="row">
         <div class="col s8 yo-align-left yo-valign-text-center yo-text-s" style="height:32px;padding-left: 6px;">{{okTot[0]}} schede</div>
      </div>

      <div class="row" :class="variabile+'-'+vitem.id" v-if="v.tipoanalisi==1" v-for="vitem in vData[0]" :key="vitem.id">
          <div class="col s4 offset-s4 yo-align-right yo-valign-text-center" style="height:24px;">{{vitem.totale}}</div>
          <div class="col s4 yo-align-right yo-valign-text-center" style="height:24px;"><div style="padding-right:12px;">{{vitem.percentuale}}%</div></div>
      </div>

      <div class="row" v-if="v.tipoanalisi==2">
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">MEDIA</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">DS</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">MEDIANA</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">Q1</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">Q3</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">Q3-Q1</div>
      </div>

      <div class="row" v-if="v.tipoanalisi==2">
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vMedia[0]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vSTD[0]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vMediana[0]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vQ1[0]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vQ3[0]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vQ31[0]}}</div>
      </div>

      <div class="row">
         <div class="col s4 offset-s4 yo-align-right yo-valign-text-center" style="height:24px;">{{ncTot[0]}}</div>
         <div class="col s4 yo-align-right yo-valign-text-center" style="height:24px;"><div style="padding-right:12px;">{{(ncP[0]>0)?ncP[0]:0.0}}%</div></div>
      </div>


   </div>



   <div class="col s4 " style="border-left:2px solid white;padding-top:8px;padding-bottom:8px;">
      <div class="row">
         <div class="col s8 yo-align-left yo-valign-text-center yo-text-s" style="height:32px;padding-left: 6px;">{{okTot[1]}} schede</div>
      </div>

      <div class="row" v-if="v.tipoanalisi==1" v-for="vitem in vData[1]" :key="vitem.id">
          <div class="col s4 offset-s4 yo-align-right yo-valign-text-center" style="height:24px;">{{vitem.totale}}</div>
          <div class="col s4 yo-align-right yo-valign-text-center" style="height:24px;"><div style="padding-right:12px;">{{vitem.percentuale}}%</div></div>
      </div>

      <div class="row" v-if="v.tipoanalisi==2">
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">MEDIA</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">DS</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">MEDIANA</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">Q1</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">Q3</div>
      <div class="col s2 yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:24px;">Q3-Q1</div>
      </div>

      <div class="row pad" v-if="v.tipoanalisi==2">
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vMedia[1]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vSTD[1]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vMediana[1]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vQ1[1]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vQ3[1]}}</div>
      <div class="col s2 yo-align-center yo-valign-text-center" style="height:24px;">{{vQ31[1]}}</div>
      </div>

      <div class="row">
         <div class="col s4 offset-s4 yo-align-right yo-valign-text-center" style="height:24px;">{{ncTot[1]}}</div>
         <div class="col s4 yo-align-right yo-valign-text-center" style="height:24px;"><div style="padding-right:12px;">{{ncP[1]}}%</div></div>
      </div>

   </div>

</div>
<!--
<div class="row">

   <div class="col s4 offset-s4" v-if="v.tipoanalisi==2" style="border-right:2px solid red;">
      <div class="row pad">
      <div class="col s2m yo-align-right">{{vMediana[0]}}</div>
      <div class="col s2m yo-align-right">{{vQ1[0]}}</div>
      <div class="col s2m yo-align-right">{{vQ3[0]}}</div>
      <div class="col s2m yo-align-right">{{vQ31[0]}}</div>
      </div>
   </div>

   <div class="col s4 " v-if="v.tipoanalisi==2">
      <div class="row pad">
      <div class="col s2m yo-align-right">{{vMediana[1]}}</div>
      <div class="col s2m yo-align-right">{{vQ1[1]}}</div>
      <div class="col s2m yo-align-right">{{vQ3[1]}}</div>
      <div class="col s2m yo-align-right">{{vQ31[1]}}</div>
      </div>
   </div>

</div>   
-->

</div>
</template>

<script>
import { quantileSeq,std,mean } from 'mathjs'

export default {
name: 'ReportBasicoVariable',
props: ['variabile','tbName'],
data() {
   return {
      ready:false
      ,answers: false

      ,v: false

      ,allTot:[0,0]
      ,okTot:[0,0]
      ,naTot:[0,0]
      ,ncTot:[0,0]
      ,ncP:[0,0]

      ,vData: [[],[]]

      ,vMedia: [0,0]
      ,vSTD: [0,0]
      ,vMediana: [0,0]
      ,vQ1: [0,0]
      ,vQ3: [0,0]
      ,vQ31: [0,0]

      ,vMedianaA : 0
      ,vQ1A: 0
      ,vQ3A: 0
   }
},
watch: {
   value: function(val){
      console.log("THIS.VALUE is now "+val+" for "+this.variabile)
   }
},
async created () {
   console.log("Created ReportBasicoVariable for variable "+this.variabile)
   this.v = this.$teras.getItemFromArrayObject(this.variabile,'nome',this.$teras._variabile)
   console.log(this.v.tipoanalisi)
   await this.makeAnalisi(0)
   await this.makeAnalisi(1)
   switch(this.v.tipoanalisi){
   case 1:
   await this.makeAnalisi1(0)
   await this.makeAnalisi1(1)
   break;
   case 2:
   await this.makeAnalisi2(0)
   await this.makeAnalisi2(1)
   break;
   }
   
      setTimeout(()=>{this.ready = true}, 1000)
      
},
mounted () {
   console.log("Mounted ReportBasicoVariable for variable "+this.variabile)
},
destroyed(){
   console.log("Destroyed ReportBasicoVariable for variable "+this.variabile)
},
methods: {
   async makeAnalisi(cc){
      let esito  = await this.$axios.query('fetchAll',"SELECT IFNULL(←variabile,-999) AS id, count(*) AS numero FROM `←rTable` WHERE NOT FIND_IN_SET(←variabile,'-127,-7') GROUP BY ←variabile WITH ROLLUP ORDER BY id;",{rTable:this.rTable[cc], variabile: this.variabile})
      for (let item of esito.result){
         switch(item.id){
         case -127:
         break

         case -999:
            
         this.allTot[cc] = item.numero
         break
         
         case -7:
         this.naTot[cc] = item.numero
         break
         
         case -9:
         this.ncTot[cc] = item.numero
         break
         
         default:
         break
         }  

         //if (item.id > -7) { break }
      }
      this.okTot[cc] = this.allTot[cc] - this.naTot[cc]
      this.ncP[cc] = (this.ncTot[cc]/this.allTot[cc]*100).toFixed(1)
      
   },
   async makeAnalisi1(cc){
      /*
      let esito = await this.$axios.query('fetchOne','SELECT  count(*) AS numero FROM ←rTable WHERE ←variabile=-7;',{rTable:this.rTable, variabile: this.variabile})
      this.naTot = esito.result

      esito = await this.$axios.query('fetchOne','SELECT  count(*) AS numero FROM ←rTable WHERE ←variabile!=-7;',{rTable:this.rTable, variabile: this.variabile})
      this.ammissibiliTot = esito.result
      */
      let esito  = await this.$axios.query('fetchAll',"SELECT IFNULL(←variabile,-999) AS id, count(*) AS numero FROM `←rTable` WHERE NOT FIND_IN_SET(←variabile,'-127,-7') GROUP BY ←variabile WITH ROLLUP ORDER BY id;",{rTable:this.rTable[cc], variabile: this.variabile})

      let itemData = {}
      
      for (let item of JSON.parse(this.v.answer)){
         itemData = this.$teras.getItemFromArrayObject(item.id,'id',esito.result)
         itemData = (typeof itemData.numero != 'undefined') ? itemData : {numero:0}
         this.vData[cc].push({
            id:item.id
            ,label:item.label
            ,totale:itemData.numero
            ,percentuale:(this.okTot[cc]>0) ? (itemData.numero/this.okTot[cc]*100).toFixed(1) : 0.0
         })
      }
      itemData = this.$teras.getItemFromArrayObject(esito.result,'id',-9)
      if(typeof itemData.numero != 'undefined'){
         this.vData[cc].push({
            id:-9
            ,label:'Non Conosciuto'
            ,totale:itemData.numero
            ,percentuale:(this.okTot>0)?(itemData.numero/this.okTot*100).toFixed(1) : 0.0
         })
      }


      //this.ready = true
   },
   
   async makeAnalisi2(cc){
      let esito  = await this.$axios.query('fetchOne',"SELECT GROUP_CONCAT(←variabile) FROM `←rTable` WHERE NOT FIND_IN_SET(←variabile,'-127,-9,-7');",{rTable:this.rTable[cc], variabile: this.variabile})
      esito = esito.result.split(",").map(x=>+x)
      this.vMedia[cc] = parseFloat(mean(esito)).toFixed(this.v.analisidecimali)
      this.vSTD[cc] = parseFloat(std(esito)).toFixed(this.v.analisidecimali)
      this.vMediana[cc] = parseFloat(quantileSeq(esito, 0.5)).toFixed(this.v.analisidecimali)
      this.vQ1[cc] = parseFloat(quantileSeq(esito, 0.25)).toFixed(this.v.analisidecimali)
      this.vQ3[cc] = parseFloat(quantileSeq(esito, 0.75)).toFixed(this.v.analisidecimali)
      this.vQ31[cc] = (this.vQ3[cc]-this.vQ1[cc]).toFixed(this.v.analisidecimali)
   }
   
},
computed:{
   rTable:function(){      
      return ['r' + this.tbName,'r' + this.tbName+'c']
   },
   _item:function(){
      let item = this.$teras.getItemFromArrayObject(this.variabile,'nome',this.$teras._variabile)
      return item
   },
   naP: function(){
      return (this.naTot[0]/this.allTot[0]*100).toFixed(1)
   },
   _answers: function(){
      return JSON.parse(this.item.answer);
   },
   dLabel: function(){
      let temporalDivElement = document.createElement("div")
      temporalDivElement.innerHTML = this.v.domanda
      return temporalDivElement.textContent || temporalDivElement.innerText || ""
      
      //let label = v.domanda.replace(/<[^>]*>?/gm, '')//<div class="yo-color-secondary title_h1">Tipo di Patologia</div>
      //return label
   }
}
}
</script>

<style >
.el-tooltip:hover{color:#F73D3D;cursor:pointer;}
</style>



